import React from "react";
import { Waves } from "lucide-react";
import { Link } from "react-router-dom";

/** Split-screen auth shell — right side is the marketing panel with brand imagery. */
export default function AuthShell({ children, title, subtitle, illustration }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      {/* LEFT: Form */}
      <div className="flex flex-col justify-center px-6 md:px-14 py-16 lg:py-24">
        <div className="max-w-md w-full mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 mb-10" data-testid="auth-brand-link">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#071b22] text-white">
              <Waves className="h-5 w-5 text-[#37768e]" />
            </span>
            <span className="font-display font-semibold tracking-tight text-[#071b22] text-lg">
              Gulf Coast <span className="text-[#165a71]">Work</span>
            </span>
          </Link>

          <h1 className="font-display text-3xl md:text-4xl font-semibold text-[#071b22] tracking-tight" data-testid="auth-title">
            {title}
          </h1>
          {subtitle && <p className="mt-3 text-[#252A34]/70 leading-relaxed">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>

      {/* RIGHT: Marketing panel */}
      <div className="hidden lg:block relative bg-[#071b22] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{
            backgroundImage: `url(${illustration || "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80"})`,
          }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#071b22] via-[#071b22]/70 to-transparent" />
        <div className="absolute inset-0 gcw-noise opacity-30" />
        <div className="relative h-full flex flex-col justify-end p-14 text-white">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#87bccc]">Local. Digital. One.</div>
          <div className="mt-3 font-display text-3xl xl:text-4xl font-semibold leading-tight max-w-md">
            Where the Gulf Coast gets real work done — from a leaky faucet to a full rebrand.
          </div>
          <div className="mt-6 text-white/70 text-sm max-w-md">
            One trusted marketplace. Verified pros. Escrow-protected payments. No lead-broker games.
          </div>
        </div>
      </div>
    </div>
  );
}
